import { render, staticRenderFns } from "./DocVehicleTypeRecognition.vue?vue&type=template&id=36b57b7a&scoped=true"
import script from "./DocVehicleTypeRecognition.vue?vue&type=script&lang=js"
export * from "./DocVehicleTypeRecognition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b57b7a",
  null
  
)

export default component.exports